import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Icons } from '@vex/icons/icons';
import { ToastrService } from 'ngx-toastr';

@UntilDestroy()
@Component({
  selector: 'vex-general-tooltip',
  templateUrl: './general-tooltip.component.html',
  styleUrls: ['./general-tooltip.component.scss']
})

export class GeneralTooltipComponent extends Icons implements OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() value: string = '';
  copied: boolean = false;

  constructor(
    private toastrService: ToastrService,
  ) { 
    super();
  }
 
  ngOnInit() {
  }
 
  ngOnDestroy(): void {
  }

  copyToClipboard(tooltip: MatTooltip, text: any) {
    if (!text) return;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.copied = true;
        tooltip.message = 'Copied!';
        tooltip.show();

        setTimeout(() => {
          this.copied = false;
          tooltip.message = 'Copy';
        }, 5000);
      })
      .catch((error) => {});
  }
}
